import { render } from "./LifecycleHooks.vue?vue&type=template&id=17e6b63b"
import script from "./LifecycleHooks.vue?vue&type=script&lang=js"
export * from "./LifecycleHooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__